import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBl8ZpdhEAveHqvVppEnV1zXCRBe8ys6MU",
  authDomain: "siftcard-bb66f.firebaseapp.com",
  projectId: "siftcard-bb66f",
  storageBucket: "siftcard-bb66f.firebasestorage.app",
  messagingSenderId: "574739848875",
  appId: "1:574739848875:web:2e6e35567b62ef258a21ee",
  measurementId: "G-QKF8JBW5J7"
};


// This "if" check prevents the "Firebase App already exists" crash
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
